
import $ from 'jquery';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import HqAccountEditor from '../HqAccountEditor';
import Spinner from '../../../util/Spinner';
import AccountsOfInterestEditor from '../AccountsOfInterestEditor';
import Toasted from 'vue-toasted';
import { WindowType } from '../../../../util';

declare var window: WindowType;

Vue.use(Toasted, { duration: 2000 });

@Component({
  components: {
    AccountsOfInterestEditor,
    HqAccountEditor,
    Spinner,
  },
})
export default class UserAccountsEditModal extends Vue {
  userId: string | null = null;
  saving = false;

  get sessionUserId(): string {
    return window.application.user.id!;
  }

  public open(userId: string): void {
    this.userId = userId;
    $(this.$refs.modal!).modal('show');
  }

  public dismiss(): void {
    $(this.$refs.modal!).modal('hide');
    this.userId = null;
  }

  async save(): Promise<void> {
    this.saving = true;
    try {
      await (this.$refs.hqAccountEditor as HqAccountEditor).save();
      await (this.$refs.accountsOfInterestEditor as AccountsOfInterestEditor).save();
      this.$toasted.info(this.$t('txtSaved').toString());
      this.dismiss();
    } catch (e) {
      //ignore, should be handled by components already
    } finally {
      this.saving = false;
    }
  }
}
